
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'backspaceKey': `⟵`,
'clearKey': `⎚ Skaidrs`,
'deleteKey': `⌦ Dzēst`,
'downKey': `↓ Uz leju`,
'endKey': `⤓ Nobeigums`,
'enterKey': `Ievadiet`,
'escapeKey': `⎋ Aizbēgšana`,
'f10Key': `F10`,
'f11Key': `F11`,
'f12Key': `F12`,
'f13Key': `F13`,
'f14Key': `F14`,
'f15Key': `F15`,
'f16Key': `F16`,
'f17Key': `F17`,
'f18Key': `F18`,
'f19Key': `F19`,
'f1Key': `F1`,
'f2Key': `F2`,
'f3Key': `F3`,
'f4Key': `F4`,
'f5Key': `F5`,
'f6Key': `F6`,
'f7Key': `F7`,
'f8Key': `F8`,
'f9Key': `F9`,
'h64cd12550420f6f1': html`Izveidot 
          <code>LICENCIJA 
          </code> failu 
        `,
'homeKey': `⤒ Sākums`,
'keyCommand': `⌘ Komanda/Win`,
'keyControl': `^ Kontrole`,
'keyOption': `⌥ Iespēja/Alt`,
'keyShift': `⇧ Maiņa`,
'leftKey': `← Pa kreisi`,
'pagedownKey': `▼ Pagedown`,
'pageupKey': `▲ Augšējā lappuse`,
'rightKey': `→ Tiesības`,
's00065e45db8c0441': `Sīkāku informāciju skatiet sadaļā Izstrādātāju rīki`,
's001dd78415a91fa0': `Ritjoslas tekne`,
's002fa7d1054ed082': `Robežu lodziņš`,
's006f872a5b7f5279': `Sangro`,
's01b16a926920908b': `Kazahstānas`,
's01b56d233c6c5cac': `Dalīšana`,
's01d32b35baa3b676': `Autors`,
's02106cc2ef0e7578': `Jauna tapa...`,
's02ab1ea8e5100fc1': `Atzīmēt atlasi kā "divvirzienu pārrakstīšanu".`,
's0312976fe9da5951': `Poga`,
's03608a32f05eded2': `Pietuvināt tālummaiņu`,
's036d35e03be98d22': `Matemātikas dziļums`,
's037b1dc850a89273': `Aizstājējs saskaņā ar`,
's0396202b716732ec': `Atzīmējiet atlasi kā pārtrauktu`,
's03f49e598ffb11cc': `Polijas`,
's0448f1059fa01720': `Saglabājiet, kopīgojiet vai izdrukājiet izpētāmo. Rediģējiet informāciju, piemēram, nosaukumu, valodu vai licenci.`,
's0458872c43beadef': `Ievietot rindu pirms`,
's04c939a414fdab21': `Tsonga`,
's050954cd4ae83304': `Vārdu atstarpes`,
's05e9759cfd99c48f': `Attaisnojiet`,
's063fa5a0a4903bf4': `Uz sāniem, no kreisās puses uz labo`,
's064339c229374050': `Kodēšana`,
's06634274f19b0572': `Tapu izvēle`,
's06743b24499f0035': `Enkura centrs`,
's07808b0ca6da8fef': `Nožogota tīmekļa vietne`,
's07970793b21351fd': `Rubīna bāzes konteiners`,
's079cf7850d9327f0': `Fonts`,
's07aa10850d9ddcc7': `Veidlapa`,
's07e6118e838b2e23': `Navigācija`,
's0816468df86e4036': `Atver iestatījumus`,
's082869038c117fe5': `portugāļu (Brazīlija)`,
's086e6c267ade2609': `Piesātinājums`,
's08e12ade32ef8125': `Setsvāna`,
's08e6bd98452e6bb9': `Audio`,
's0978fb5ba3145996': `Ievietot sarakstu (nesakārtotu)`,
's09c3f1d21de14ae1': `Atzīmējiet atlasi kā pasvītrotu`,
's0a2d91c6720033e9': `Teksta atstarpju apgriešana`,
's0a3ddcba94027d95': `Objekta atbilstība`,
's0a6cb8d42cdb0c4a': `Esperanto`,
's0a799f583098cadf': `Ievietojiet navigāciju`,
's0a7db790db1fc45c': `Atzīmējiet atlasi kā intervālu`,
's0b1271f50a77dc73': `Satura lodziņš`,
's0b24d08ea349b455': `Viss, ko varat ievietot. Sākumā ir neinteraktīvie elementi, piemēram, saraksti vai attēli, bet pēc tam interaktīvie elementi, ko sauc par logrīkiem. Varat iegūt jaunus, noklikšķinot uz meklēšanas joslas.`,
's0b7ae9543c001867': `Atbildēt`,
's0bdca49248ba4820': `Īsceļi`,
's0befccf152b6c0a9': `Orientēties no metadatiem`,
's0c11e479416c8421': `Tabulas virsraksta ievietošana`,
's0c27336067c59611': `Ritināšanas polsterējums`,
's0c4593d81f147042': `Pamatlīnija`,
's0c4b2e98d4ab7f5a': `Lietotņu komandas`,
's0c883713b83616a8': `Saglabāt aktīvo dokumentu`,
's0ca5c0460199cba1': `Saīsinājums`,
's0cf10c4f40588f8d': `Tabulas virsraksts`,
's0d86afa3c6a1e28b': `Flex virziens`,
's0dad143dff0079fc': `Malajāļu valodā`,
's0db05bd7ba6fff96': `Jūsu izpētes dokuments. Šeit varat rakstīt tekstu un kopēt/ielīmēt, rediģēt utt.`,
's0dc07f97c821463c': `Komentāru atlase`,
's0dc452999c129e15': `Iespējot pārlādēšanu tiešraidē`,
's0de0febab8a4beaf': `Kļūda, lasot šo paketi`,
's0e44968489e076a8': `Ķīniešu`,
's0e4862e87c7d53ce': `Atzīmējiet atlasi kā citātu`,
's0e6ea8870dbddab2': `Dokumentu komandas`,
's0ee28503778e4c0c': `Pēdējā bāzes līnija`,
's0ef01c03299bbb83': `Apdare`,
's0f17f32919661cff': `Mongoļu`,
's0f350bc4e538e3ea': `Vārdi`,
's105540b7756c0232': `Definīcijas termins`,
's105a06836c40fcb4': `Atlasīto elementu filtru, krāsu un sajaukšanas iestatīšana`,
's106b274b5af798e5': `Teikumi`,
's1082e1649793dca9': `Atzīmējiet atlasi kā definētu terminu`,
's10f3845975a0351e': `Rediģēt metadatus`,
's1125d159f7e64df5': `Displejs`,
's11326fd2590f4e5e': `Noklusējuma`,
's1155ec07a221e739': `Ritjosla`,
's1173bf7a3e0b74c9': `Minimums (y)`,
's1177237a3e0e548c': `Minimālais (x)`,
's1219d97b49650c05': `Redzamība`,
's123bea44f38abccf': `Ievietot objektu`,
's1245e2cb9f20197e': `Saskaņot`,
's12946ec1b850962c': `Kolonnas ievietošana pēc`,
's1351209ef74ee729': `Visu kolonnu izvietojums`,
's13c60cb409e8cb6f': `Izlīdzināt centru`,
's13ebd619c8a06a6d': `Tīkla automātiskās rindas`,
's13ef8ca26ca8861b': `Izgriezts elements`,
's151349210ac1d2d8': `Grupas ievietošana`,
's151bc2eea7a032a4': `-neizmainīts-`,
's153bc3c3aa39587b': `Galda galva`,
's156647179b21d351': `Tabulas korpusa ievietošana`,
's158b6ec6b1fffcb2': `Pārtraukums pēc`,
's15d0c0657c1ee08c': `API atslēga`,
's1626a7e10a9f9dcc': `Iestata atlases fontu ģimeni`,
's1637c7d1a30629e2': `Robežu lodziņš`,
's1641ab440bf4daa4': `Atjaunināt šo logrīku paketi`,
's166bd56d19670a72': `Palielināt`,
's1696c76a23c0834e': `Uzlabotas: Rādīt paketes ar tādām versijām kā 0.x.x pakotņu pārvaldniekā`,
's16b9446e3a70e1f4': `Atribūti`,
's16f205466761e583': `Nav optisko fontu izmēru noteikšanas`,
's16f2f1c2c516d307': `Atvērt dokumentu`,
's1749014f3f87fa6a': `Stretch`,
's17597a8bb4810524': `Licence`,
's17bfaaa4e7528bc7': `Baškīru`,
's17fb3f4805f4f4b9': `Noņemt lauku`,
's181ef198cf83ec3a': `Bihari`,
's1857db526dc4dcdd': `Izveidot paketi`,
's18d5c44aae3dc82a': `Tiešsaistē rediģēšanas laikā`,
's1988d71ef8060edf': `Tabulas rindas ievietošana`,
's19abee1277c9bca2': `Samoan`,
's19daf2f26c19543d': `Kontūra`,
's1a1acc902e6668e0': `Rādīt uzlabotu teksta formatēšanu`,
's1a5230a71d9285c1': `Capture`,
's1aa1cb63ad44bc6f': `Kolonnu atstarpe`,
's1af8b67d1c85c811': `Telpa starp`,
's1b4a36fce2456660': `Fontu ģimene`,
's1c246045629b0016': `Atzīmēt atlasi kā dzēšanu`,
's1c3fc313a9184670': `Publiskā saite`,
's1c65f5004a07dcfa': `skotu galiešu valoda`,
's1c690963f1e2df00': `Platformai specifisks izskats`,
's1ca22ce85e074da5': `Pragma`,
's1d10d2058d8ca8dd': `Vēlaties īsu ekskursiju gida pavadībā?`,
's1d19244f549ec535': `Izglītība`,
's1d5c7b28e8b50d6d': `Asociētais grāds.`,
's1db591f5a54dbfd3': `Satura lodziņš`,
's1dbb9f50e16c92a3': `Robežu rādiuss`,
's1dfb744260fb3a01': `Divvirzienu izolācija`,
's1e9c2c654732cc5f': `Baltkrievu`,
's1eaccbf2d6af8ab5': `Informācija`,
's1efbfc3937d565bd': `Pamatinformācija`,
's1f2b49c1bca2035d': `Kataloniski`,
's1f74bdf32b51a5fc': `Fona attēls`,
's1f7698c061c208c9': `Atvērt`,
's1f8e59d0624842ff': `Kannada`,
's1feab14d837eadb0': `Guarani`,
's20deffeecf2699fb': `Korsikānas`,
's21d61916eb8d137d': `Galda virsbūve`,
's21d723a1dbcd89c8': `Javas`,
's21f8a2eaf5a70749': `Ievietojiet etiķeti`,
's2206c42e5b835e6e': `Atzīmējiet atlasi kā saīsinājumu`,
's22a2348c46a912a0': `Iekļaut sadaļu`,
's233ae776268cd44b': `Uzņēmējdarbība`,
's236ed7ba747099b0': `Fonta svars`,
's2474e7fb1aec9f05': `Tests`,
's2492f5fb1b05b45e': `Teksts`,
's24949d7adbb5a098': `Toolbox`,
's252a52330d32b900': `Metadati`,
's2540844a4bc4d9ba': `Prasīt atribūciju?`,
's255857544a9d5ec0': `Atiestatīt`,
's255c77900f2b5e0f': `Krāsu shēma`,
's256ab831a48c941c': `Noņem visu teksta formatējumu no atlases`,
's2591806d7b222591': `Atiestatīšanas izmaiņas`,
's25e1a07e454c2c11': `Tīkls`,
's262abbaf1d05f009': `Maigā gaisma`,
's266935f2447fcd98': `Virs kreisās`,
's268ecd1cef45a9a8': `Vai esat pārliecināts?`,
's2692bc028fed91f1': `⇪ Caps Lock`,
's27056379e0acfdb0': `Atvieglot`,
's27076e66c5d483ba': `Vertikālā izlīdzināšana`,
's2712dc5641a33226': `paketes reģistra konti ir paredzēti izstrādātājiem un ļauj konfigurēt vienu vai
          vairākus reģistrus.`,
's2739460e44320108': `Ķīniešu (tradicionālā)`,
's27cc88818cc46ff6': `Stabils`,
's281d957112b10f12': `Dokumenta HTML rediģēšana tieši`,
's28b6246ce616a548': `Tabulas kolonnu grupas ievietošana`,
's29a1c26521879b9f': `Samazināt mērogu`,
's29acfd2778e8c377': `Slēpt uzlaboto teksta formatēšanu`,
's29b24c06315e9343': `Ievietojiet ievadi`,
's29eb103449472e3b': `Ievietot virsrakstu (3. līmenis)`,
's29ee7434494a0dfe': `Ievietot virsrakstu (2. līmenis)`,
's29f21c34494d614d': `Ievietot virsrakstu (1. līmenis)`,
's29fbfc3449557f72': `Ievietot virsrakstu (6. līmenis)`,
's29ff743449588131': `Ievietot virsrakstu (5. līmenis)`,
's2a031834495bcdb4': `Ievietot virsrakstu (4. līmenis)`,
's2a75c946ef4dcab7': `Dažādi`,
's2b2ae20d26f78ac2': `Bloķēt`,
's2b8f50c64be440f7': str`Atlasiet 
          ${0}... 
        `,
's2ba5f4d8f3bd7c57': `Pasūtījums`,
's2bad2d24def4aa0b': `Līnijas pārrāvums (CJK lang.)`,
's2ceb11be2290bb1b': `Atcelt`,
's2ced8e8fafb499f6': `Dzēst elementu`,
's2d986d31f8d67357': `Lauka kopas ievietošana`,
's2d995a37cf5e4995': `Ievietojiet NoScript`,
's2de969afacdaa7a6': `Forma`,
's2df075aface0dab8': `Dalīties`,
's2e192b19ed15fcf6': `Lapa`,
's2e39b99cf23606fa': `Atlasīto elementu izkārtojuma iestatīšana`,
's2e4818861000b13f': `Izkārtojums`,
's2e66bf8b833858f3': `Uigur`,
's2e969a451b4955d1': `Marati`,
's2eda5288a65bca1d': `Pārplūšana (y)`,
's2edd6688a65e21f0': `Pārplūšana (x)`,
's2f0bcdffc92a786b': `Peldēt pa labi`,
's2f2044f2431a32d5': `Virsraksts`,
's2f4d4bfbc466d91f': `Albāņu`,
's2f8da2cb5f236588': `Jūsu paketes nosaukums. Jābūt ierobežotam, piemēram, \`@org/pkg\`. `,
's30cce87854901922': `Pirmsskolas`,
's3124653c272f054c': `Kolonnu noteikumu krāsa`,
's314a4f7685c8e824': `Vienmēr`,
's31c06e226322f065': `Izvairieties no bāreņiem`,
's323dcde72b850272': `Publiskā piekļuve`,
's32911e52ee8ac745': `Ievietojiet slotu`,
's337a1e9022a8d19f': `Tabula`,
's33c1450d2822bb0f': `Ievietojiet attēla virsrakstu`,
's33c18d5a4cbffa2a': `Īru`,
's33f85f24c0f5f008': `Saglabāt`,
's342b0cabfa672822': `Palīdziet lietotājam atrast jūsu logrīku`,
's3437e0d9899e7ae1': `Nosūtīt telemetrijas datus par WebWriter lietošanu.`,
's344ea8f4939cdc98': `Krāsa`,
's34dcda3b0f9d5a98': `Pārslēgt url`,
's34f724979a124c50': `Iestata atlasītā teksta fona krāsu`,
's355b21b89ce5d9c5': `Sīkāka informācija`,
's35ae5f4e0fa2777b': `Pielāgota izlīdzināšana`,
's35aeaff1425bca9e': `WebWriter neatbalsta mediju tipu `,
's35c3125c7750681e': `Bloka citāts`,
's3643189d1abbb7f4': `Kods`,
's3649bacefe731bf6': `Pārslēgt rīku kastīti`,
's365280e16a8ea32d': `Atlases kopēšana`,
's366991b9c9287765': `Tiesības`,
's36a194e38d653a26': `Datu anotācija`,
's36b3cefdcb897f15': `Perspektīvas`,
's372fae706048ce41': `Parastā un nepāra`,
's377e24af9628c37e': `Pasūtītais saraksts`,
's37a8c35f6581da5f': `Nav enkura`,
's37fa3b9cd51c2dfd': `Iestata atlases fonta lielumu`,
's380d17664bb69531': `Kolonnas ievietošana pirms`,
's3815184eb09f0dcf': `Kursors`,
's382a2aa3984474dd': `Izveidot`,
's38980f98cb07ceb8': `Saglabāt aktīvo dokumentu kā kopiju`,
's3914cb410fca44d4': `Importēt`,
's3a179f6db2972384': `Rubīna pozīcija`,
's3a5ca02f282d247e': `Dalīties...`,
's3ae67088bbefba98': `Iepakojumi`,
's3b0ab4b52326316f': `Gaisma`,
's3bc203a3f8a6409c': `Atjaunināt valodu visā dokumentā`,
's3bdad99768e11911': `Izpētāms`,
's3cb47df8290fa94c': `Ievietot opciju`,
's3cf89cb47fdde7e9': `Saite`,
's3d09398e555ee5f9': `Paplašinātās opcijas`,
's3d249bb480032121': `Saraksts`,
's3d3efd1e19bdcfb4': `Date/Time Anotācija`,
's3d6a732c792ccb9e': `Ruby anotācija`,
's3d93f9ea0c5a13fa': `Attēls`,
's3d9548e211b958ce': `Izlaist pārklāšanos`,
's3e092e9d1ee2c5bb': `Klips`,
's3e78ddc9a48a608d': `Diezgan`,
's3eb6d1e6e79ed7c4': `Nav atrasti dokumenti`,
's3eca5a034978754b': `Izdzēst atlasi`,
's3f06e9abb6ebcb79': `Rakstzīmes`,
's3f1e7a3f2b283d3b': `Rezerve`,
's3f299e83cbf52fba': `Zhuang`,
's3f43ef2eaa1ec486': `Gudžarati`,
's3f7e097a9b2e6181': `Ievietot rakstu`,
's3fd83566dd643d10': `Ievietot leģendu`,
's3fe72792941c18f9': `Teksta apakšdaļa`,
's3ffcdc5db5e7d0c5': `Reversais`,
's40e3826b7f74a3b5': `Pan (pa labi)`,
's40f07d7859284a44': `Dominējošā bāzes līnija`,
's4101ada154a1b958': `Middle`,
's410c465a5993f82d': `Līnijas pārtraukuma iespēja`,
's41322d19c928c603': `IKT`,
's417b90913e05bc17': `Priekšskatījums`,
's418f2020fe996832': `Apstiprināt izmaiņas`,
's41c724f0698148e9': `Atlases atzīmēšana kā tastatūras saīsnes`,
's41f65a763f8e44ab': `Tabulu galvenes grupa`,
's42721130228841b0': `Insulta kaste`,
's429bd646f1cf8bc6': `Gramatikas LLM konti ļauj izmantot Gramatikas LLM API, lai tekstā labotu gramatiku.`,
's429dd933ba95549b': `Ievietot adresi`,
's42e470ef1d707a28': `Automātiskā atskaņošana`,
's42ffdab1291fb3de': `Ievietot rindu pēc`,
's430831017f3f0499': `Skew (y)`,
's430bd5017f42511c': `Skew (x)`,
's433ba70286202ceb': `Pārtrauciet visus`,
's441b20a8a50e36b4': `Maķedonijas`,
's445b8acb9206db6e': `Izmest un atcelt`,
's446a924922651ea0': `Teksta uzsvars`,
's44cdba92713de38e': `Režģa apgabals`,
's45518abd911471d0': `Horvātijas`,
's456a8d744313852a': `Telpa ap`,
's4634541f5056a546': `Abhāzija`,
's46d4abe6255cb9e1': `Atkārtota īsceļu piešķiršana`,
's4730c232e7209c40': `Apgriezt abas`,
's474f0eec369d02a4': `Izvades paraugs`,
's47a8f6dfb38b9701': `Telugu`,
's47e257ae643b5851': `Atzīmēt atlasi kā datuma/laika anotāciju`,
's47ebf3a8fb3b10c1': `Orientēšanās`,
's4802bb8eb52fbdeb': `Portāls`,
's4802e47fe2e95134': `Iespēja`,
's491d2919cd6ec3d9': `Hue`,
's497838412cb455f2': `Teksta ēna`,
's4993444bfd3f3e5e': `Collapse`,
's49ad24935b14e3df': `Kečua`,
's49c560aecfeb8c29': `Maska`,
's49dd67aed00029ef': `Matemātika`,
's49e763aed00877a8': `Galvenais`,
's4a894f57eba1cf1e': `Tastatūras saīsnes`,
's4ac1ad6ecd6bd810': `Misc. red.`,
's4ad6e9d3c2365c98': `Cietā gaisma`,
's4b2c143acf931122': `Līnijas augstums`,
's4b58c01e2578f5e4': `Leģenda`,
's4bbff4e008690da1': `Izvairieties no lapas`,
's4c402ff5355fd310': `Divvirzienu pārslēgšana`,
's4caed5b7a7e5d89b': `Angļu valodā`,
's4cb38675a21b2c98': `Neatbalstīts īpašības tips '\${desc.type}' (apstrāde kā JSON)`,
's4cc8391f172c0cdf': `Atbrīvot ekskursiju`,
's4ce8cc041a628847': `Ja tiek mainīta dokumenta valoda, attiecīgi tiek atjauninātas visu logrīku valodas.`,
's4d528b416ac8dee2': `Virsrakstu grupas ievietošana`,
's4d546f6c87128d5b': `Vispirms kosmosā`,
's4dcb9315f6527f9c': `Palaist pēc atkārtotas ielādes`,
's4e191bdb4700a6e9': `Pārskrējiens (x)`,
's4e1c7fdb470386ac': `Pārskrējiens (y)`,
's4e2562fe3990e621': `Kļūda, savienojot`,
's4e361bf8eef3759a': `Vārda pārtraukums`,
's4ea0f21fc2a338a1': `Pārvietot uz augšu`,
's4eace13b3ed74187': `Blakus komentārs`,
's4efee5b48a4593cb': `Cilpa`,
's4f26e7cb7c0a8318': `Vektoru zīmējums`,
's4fd2e638aabb0bb3': `WebWriter atbalsta daudzu dažādu avotu iestrādāšanu. Vienkārši ielīmējiet saiti uz
          saturu no:`,
's4fda04cbc245e18b': `Alpha`,
's4ffac3fb33a2ee9b': `Taizemes`,
's5015a8fb33b98872': `Plāns`,
's50489ffb1bde152e': `Ievietošana`,
's5068560b8d39663d': `Klikšķināmā karte`,
's517acbf1f96324f9': `Svars`,
's523eb9043213ff0d': `Kursīvais`,
's52777d434baeed9b': `Ievietot progresa indikatoru`,
's52af5d7ac34c2163': `Tabulas rinda`,
's52e0bdc3ee304436': `Ievietojiet skaitītāju`,
's52fb1524cb25d7ab': `Jauns pavediens`,
's531056f039febd39': `Ievietojiet atlasīt`,
's536695196d0b6dc3': `Fēru salas`,
's542fcefa0bbaed86': `Atveriet vai aizveriet rīku kastīti (tikai šauros ekrānos, citādi rīku kastīte vienmēr ir redzama sānos).`,
's5432ad3c84273229': `Attēls`,
's543906d1db8b2283': `Rediģēt `,
's543c237e8c895ce8': `Bislama`,
's545ee1f373f249cf': `Kambodža`,
's54897f2764b0e4d0': `Instalējiet šo logrīku pakotni`,
's54cbfaf2a8da7818': `Pashto`,
's550839f3e4e205bb': `Atzīmējiet atlasi kā ļoti svarīgu`,
's55905c735052d295': `Tematiskais pārtraukums`,
's5590dbf7e425789d': `Etiķete`,
's5623aa2f83b05c76': `Tibetas`,
's564d1648b1ceee9f': `Aktualizēts`,
's565cd5ffb0158c46': `Izvairieties no reģiona`,
's571a4f19e2f140c7': `Pan (x)`,
's571db319e2f4208a': `Pan (y)`,
's575e795c45e2d97e': `Atgriezties`,
's5787c6d5b3b5541a': `Klipa ceļš`,
's579c69f419b6caef': `Gluds`,
's587ac858dd80f6fa': `Indekss`,
's58bec0ecd4f3ccd4': `Stingri`,
's59404f5593c32fdc': `Fontu kerning`,
's5941292bb77281ab': `Norvēģu bokmål`,
's599dcd2472c75c19': `Punkts`,
's59b20e8af32606ed': `Afar`,
's5a1a0898baf20675': `Atzīmējiet atlasi ar datu anotāciju`,
's5a356677b61a6b7e': `Moldovas`,
's5b474b5c0ac0c7c4': `Tabulu kolonnu grupa`,
's5b517ac216f9ee62': `Uz sāniem`,
's5b8cc9bb61ddce15': `Ievietot rindkopu`,
's5bba2ac2e53bd1fd': `Kirghiz`,
's5be80ad6b8301710': `Inline starts`,
's5c1ecf88259b79f9': `Prezentācija`,
's5c2a1a52c0389c30': `Inženierzinātnes`,
's5c63af7695445fcf': `Teksta stils`,
's5d18ca4c3111be6f': `Tabulas galvas ievietošana`,
's5d87c1e588f48d90': `Prakse`,
's5d929ff1619ac0c9': `Meklēšana`,
's5da52af9b083c29a': `Modelis`,
's5dc77784260a7236': `auto`,
's5e27738a2e8eb763': `Pierakstīties`,
's5e2cba97c0d971bd': `Pārlādējiet paketes`,
's5e53415a6d5719ad': `Sociālās zinātnes`,
's5e6a7a0c30d2a270': `Izlaist pārklāšanos (automātiski)`,
's5e9e8e4d21bafedc': `Pārtikas ražošana`,
's5ed03bb1f3a15949': `Attēls`,
's5f43af3669b1e098': `Avots:`,
's5feaf7fd7ee567c8': `Pārtraukuma vārds`,
's600fd23c9ce971e8': `Aktīvā dokumenta drukāšana`,
's602bbd28dae2c60f': `Pašsākums`,
's60ff598dfcf2c773': `Saskaņā ar tiesībām`,
's61053f0e3ebbd272': `normāli`,
's613c6ff83883c04f': `Tabulas sleja`,
's6196153c4b0c1ea0': `Uzstādīt`,
's61c017f6d5c303af': `Frīzu valodas`,
's61ded17ca3f48c82': `Pasvītrojuma nobīde`,
's61eacb19db252f5e': `URL`,
's621ad19d35ba7742': `Kopēt atlasi`,
's624e31cd4f1b89d4': `Gluda ritināšana`,
's626daf42b1ab7df7': `Izlīdzināt pa kreisi`,
's6280bf993915c57a': `Ritināšanas rezerve`,
's62b857f5b6693742': `Inupiak`,
's63d894b1ddb06289': `Apraksts`,
's63dfc5b1c1c27849': `Jidiš`,
's63e03c70f67ebf9c': `Konteksts`,
's63e71d20d1eaca93': `Vācu`,
's640bc7710d0143ce': `Pēdējo atcelto izmaiņu atkārtota veikšana aktīvajā dokumentā`,
's64dc1fc7e3db45c9': `Izveidot jaunu dokumentu`,
's65ac276544ba33cd': `SVG fails`,
's66765c420ee578e4': `Vienmērīga telpa`,
's669b18c6d2d9c95b': `Nav`,
's6747dbf4ad6063ba': `Self beigas`,
's6787497df07fa97e': `Var ritināt pa pieturām`,
's67c2b60a506a09e4': `Vidusskolas red.`,
's680bd4d926cd5a84': `Saglabāt 3D`,
's6827930ef1aeaf99': `Bāzes URL`,
's684a16f3c711394d': `Vairāk nekā pa labi`,
's687e27f036a71b32': `Izolēt`,
's68b87d7b61052dc3': `Tabulas rinda`,
's68e0e3a2bab7ce3e': `Izvairieties no`,
's690da6b432987c6f': `Automātiski dublē izmaiņas pašreizējā dokumentā. Izmaiņas tiek atjaunotas, kad WebWriter tiek ielādēts no jauna.`,
's69311c4e25074fb3': `Vidusskola`,
's697400b541fbc3cd': `Zem`,
's6988ab5d47593a26': `Jums ir jaunākā WebWriter versija.`,
's69a49786a8009f43': `Atrodiet paketes...`,
's69b12144dbb6544d': `Laosas`,
's69d88ef4b2618980': `Vāks`,
's69fbbdb8ad2a084a': `Aptumšojiet`,
's6a31eff1ec4f71ad': `Slēpt aizmugurējo seju (3D)`,
's6ac62e1c8c66f3bb': `Kompakts superscr.`,
's6b585ba37cdb8260': `Mantot`,
's6b61f8abf89586be': `Ebreju valodā`,
's6bd7a02fdf93e653': `Saskaņot saturu`,
's6cfc66b824ea05ba': `Kraukšķīgas malas`,
's6d02dc19e21eb49c': `Top`,
's6d1df519e235a6cf': `Twi`,
's6d60d595cb5070da': `Vjetnamiešu`,
's6d8b3b8047ed378d': `Sajaukšanas režīms`,
's6d8c02aee480af7a': `Izvēlne`,
's6dadeaaee49d6d18': `Meta`,
's6dfb502188a8c7c2': `Ievietot stilu`,
's6e288a119281f4c2': `Teksta atveidošana`,
's6e4c20c6debcd5ca': `Pielāgotu attaisnot`,
's6f84199e62584905': `Iepriekš formatēts teksts`,
's6fb3053e7244d326': `Citas jomas`,
's70178e04a3b691b6': `Atvērt iestatījumus`,
's7031ca562378bde6': `Ģeometriskā precizitāte`,
's7060970b5ed20a58': `Interaktivitāte`,
's7136449045eff28c': `Tamil`,
's71940c32987f675f': `WebWriter Cloud`,
's71a0549fd71219c9': `Rādīt nestabilas paketes`,
's71dec51005acc1e4': `Rindu blīvums`,
's72f2a02e2a5a4ee3': `Mediji`,
's730182ad28374cda': `Objekts`,
's731678e227a20559': `Šī ierīce`,
's736904f276fbd441': `Dabas zinātnes`,
's739544d0c858c633': str`Vai nomest 
          ${0} šeit 
        `,
's73cb20c838e761e1': `Griezumu izvēle`,
's7417792bbe720149': `Pārtaisīt`,
's741fae02b3dd24f3': `Pixelated`,
's743f778233e42a3f': `Ievietojiet papildinformāciju`,
's744d993d03f29851': `Ekrāns`,
's74540c1b595a229c': `TeX formula`,
's748c0074eff45884': `Manipulācija`,
's74aa0039a87141e2': `Elipses`,
's74b9781bacfcc87c': `Pendžabi`,
's74cd20a7aece9b91': `Aizpildiet lodziņu`,
's75109f5307578a61': `Laipni lūdzam WebWriter`,
's75a27f43413e02c5': `Franču`,
's75d83fc3f0cfab40': `Virsraksts`,
's762e5704cc84089d': `Atlasīto elementu citu stilu opciju iestatīšana`,
's77318393dfdb0775': `Noņemt rindu`,
's77e594ddcc10c774': `Atļaut komerciālu izmantošanu?`,
's780099588362f80f': `Definīcijas postenis`,
's782eac2b3e80323d': `Atzīmējiet atlasi kā uzsvērtu`,
's782f286a79cca35d': `Relatīvais`,
's78673a3539cb1915': `Augšā pa kreisi`,
's78789724e789221c': `Izmērs`,
's789ff24c8f03f1a4': `Attālums starp burtiem`,
's7995733bf97c01cc': `Serbu horvātu`,
's7a99528e7b64635a': `Okcitāņu`,
's7aaf0c06e69600f1': `Kļūda ar `,
's7ae49e142487766c': `Kopienas piekļuve`,
's7af555180b30a947': `Atveriet izstrādātāja rīkus`,
's7b4ba250601b8667': `Šablona ievietošana`,
's7b560d8693ed8f42': `Vertikālais`,
's7b9994904c4f5b54': `Tadžiku`,
's7bdf0fd5b014d36c': `Liela nozīme`,
's7beb1e77e82363eb': `Pēdējo izmaiņu atcelšana aktīvajā dokumentā`,
's7c61118554a0ec36': `Maksimālais (x)`,
's7c95876637f6a9d7': `Filtrs`,
's7cb4e55c59663b1c': `Uzņēmums`,
's7cfe12cd14df9950': `Izrakstīties`,
's7d27db3c9639c6dd': `Alternatīva`,
's7d8103f6f06f83d6': `Polsterējums`,
's7d864465dddbb50d': `Atļaut mainīt lielumu`,
's7de0e28d6c309a4e': `Atļaut skārienu darbības`,
's7dea785045c3cc74': `Nospiediet jaunu taustiņu kombināciju...`,
's7e0b179d4d1414eb': `Ievadiet saiti`,
's7e6570f2f1ae320f': `Sintezēt burtu veidus`,
's7ecb1f29332293e5': `Saskaņošanas bāzes līnija`,
's7ed13ccddb1bf3c3': `Pārklājums`,
's7edbe0b213199995': `Bakalaura grāds`,
's7ede1c55e35ce9d6': `Simulācija`,
's7f09197a4814079b': `Atlasīto elementu interaktivitātes opciju iestatīšana`,
's7f326a142e856656': `Stils`,
's7fcb35d23be1e643': `Lauka komplekts`,
's80570196a9ce6d11': `Ieslēgt telemetriju`,
's806f84eb0ace116e': `Skatiet, kas ir atlasīts, un mainiet to. Kopējiet, izgrieziet, ielīmējiet, piespraudiet vai veiciet izkārtojuma izmaiņas. Piedāvā dažādas opcijas atkarībā no atlases, piemēram, teksta formatēšanu.`,
's80a42b81c52d4d8f': `Kārtojuma krāsa`,
's80b71fc6f43c5ce1': `Loose`,
's812cbda653daaeba': `Šī funkcija vēl nav ieviesta`,
's81c3d8809658b951': `Kašmiras`,
's81cf65c5a46dea08': `Kinyarwanda`,
's81ecf2d4386b8e84': `Turpināt`,
's8247d32213e35f24': `Ievietojiet galveno`,
's82665b2ffabc9c0a': `Tīmekļa vietne`,
's828b1ecea8715884': `Pan (pa kreisi)`,
's833bd0422a7ef95d': `Cilnes izmērs`,
's83420ad7b6a14db5': `Pārslēgt Dev rīkus`,
's83c15613b6f6f3c8': `Tikai tiešsaistē`,
's83cd32b685ccc9b7': `Kontrolierīces`,
's83f26d02dd7aa681': `Redzams`,
's840fa49e8989c028': `Atrašanās vieta/forma`,
's844a76d1843ceb3c': `Atiestatīt noklusējuma iestatījumus`,
's84e4e8ae645b82ac': `Augšējā labajā pusē (y)`,
's84e9c7f8785ca60b': `Ievietot veidlapu`,
's8517ae4da104b004': `Tabulas kolonnu grupa`,
's85186a61e0d55bac': `Video`,
's851a7deea5984646': `Licence kā Creative Commons OER?`,
's85f9aa6d3ea0e421': `Tabulu pēdas grupa`,
's864b0e6270e97246': `Atzīmējiet atlasi kā blakus komentāru`,
's8670e5ad3bf0dcf8': `Saglabāt kā`,
's8688d74dd3716d6e': `Komandu tastatūras saīsnes`,
's86ca34c5287a2f38': `Wolof`,
's86f820d8007d0de4': `Formas rezerve`,
's87cefc710b3567fb': `Satur`,
's88676f992b2965db': `Izstiept šūnu saturu`,
's886897f2fd4edb99': `Slēptais`,
's886c5db2a5579873': `Koncepcija`,
's888c71e8fcb916d3': `Automātiskā saglabāšana`,
's88a62d29529948fb': `Tabulas ievietošana`,
's89950d86c8004d4b': `Neizlaist pārklāšanos`,
's89bca7498f20e041': `Fona klips`,
's8a28bad9290d4761': `Oromo`,
's8a29cb39a42f83f3': `Pārtraukums pirms`,
's8a4ff2bd9c13498c': `Ieraksts`,
's8a6585c48ea104e9': `Slēpt tukšas šūnas`,
's8a9eb438abac7c6a': `Etiķetes`,
's8b0432eecbd8b034': `Atjaunināt`,
's8b7580c35e2aef87': `Augšējais kreisais stūris (y)`,
's8bc4affa761aa8a2': `Ievietot attēlu`,
's8c7f51cb067644c7': `Datu saraksts`,
's8d342ecaa9e75b9b': `Attiecības`,
's8d797888455f4147': `Pārtraukumu telpas`,
's8d83386457e91813': `Atcelt/atjaunot izmaiņas vai veikt priekšskatījumu no audzēkņa perspektīvas.`,
's8d8643013a7754d1': `Teksta izlīdzināšana`,
's8df30fe2a50d3479': `Ievietojiet rindu pārtraukuma iespēju`,
's8e715248c3a78446': `Izgriezt atlasi`,
's8f29e48d6b9a1aa8': `Tabulas galvenes rindas ievietošana`,
's8f4be9f086eb530f': `Atcelt`,
's8f533296a536965e': `Saglabāt kā...`,
's8fad58c831ecf017': `Rubīna teksta konteiners`,
's8ffe7abcbed8eb43': `Vertikāli, no kreisās puses uz labo`,
's90105521fcc40453': `WebWriter Cloud konti ļauj jums saglabāt dokumentus tiešsaistē un kopīgot tos ar
          skolēniem. Pievienojiet kontu šeit, un tas būs pieejams kā vieta, kur saglabāt, ielādēt,
          kopīgot un atvērt dokumentus.`,
's9095f01a80a91594': `Super`,
's90f0fbc12e1e2b2f': `Fontu palete`,
's90f7c1cf501ea0a7': `Krāsu izvairīšanās`,
's91093e0b087911ba': `Uzsvars pozīcija`,
's919e1724f589c9b1': `Slot`,
's91c5ed7769d00b65': `Ievietot embed`,
's9219acd5bef6269e': `Zem kreisās puses`,
's92548405912d46bf': `Ritināšanas izlīdzināšana (y)`,
's9258280591309342': `Ritināšanas izlīdzināšana (x)`,
's927d796559f49439': `Fona izcelsme`,
's92b177e579ef7b97': `Uzsvars`,
's92f846b9be2e8e8d': `Atzīmējiet atlasi kā slīprakstu`,
's93566b84230af4f5': `Ievietot attēlu`,
's936aa0b239679585': `Ievietojiet tematisko pārrāvumu (parasti attēlots kā horizontāla līnija).`,
's9370dc6afa716b57': `Robeža`,
's93f083e654a45715': `Breton`,
's94653c76b2d86a04': `Definēts termiņš`,
's9485af2e7cd9418f': `Sākumskola`,
's94d2eee44b292567': `Pārslēgt papildu opcijas`,
's94d61907ee22a8c1': `Korejas`,
's94eb1effbbb6498b': `Pārplūšana`,
's951aa3a6439f1271': `Saraksta marķieris`,
's9565553d163fc92a': `Skripts`,
's957787fc6b7ea5c0': `Pan (uz augšu)`,
's95d56e58f816d211': `Holandiešu`,
's95d8e41a64635c7c': `Baltā telpa`,
's95de7e1eff6c053e': `Horizontāli, no augšas uz leju`,
's960d3a90ac199368': `Reito-romāņu`,
's96532132a29dd542': `Ievietot audio`,
's96a045dcade75ad0': `Blīvs stabiņš`,
's9781a5bb3fcb26a3': `Vispirms izvēlieties uzņēmumu`,
's978522fbc9577a7e': `Somālijas`,
's97881699a2b21d5b': `Rindu atstarpe`,
's97aa76056a81bd36': `Metrikas`,
's986facb3ecc9602c': `Uz sāniem, no labās puses uz kreiso pusi`,
's987abd19fac8cf55': `Sub`,
's9896529e5cb20558': `Ārējais fails`,
's98977a87d1b93941': `Informācijas, stilu un skriptu atiestatīšana`,
's98b1cb8fb62909ec': `Grupa`,
's990d0e0fa2ab00b5': `Galisijas`,
's99229574e5692f19': `Grenlandiešu`,
's99a990f3841ad283': `Faili `,
's99b38e000175cc84': `Pārsvītrot`,
's99f110d27e30b289': `Nosaukums`,
's9ab10fbf4c7a7322': `Pasvītrot pozīciju`,
's9abadcc828884d7b': `Teksta laukums`,
's9b7cd8860c8fc922': str`
          ${0}
          tiks pārrakstīts. Vai esat pārliecināts? 
        `,
's9c11f2d9335d8bd1': `Oriya`,
's9c356016f81585f6': `Fona krāsa`,
's9ca757effd747da9': `Urdu`,
's9caf10388ab3562f': `Tabulas sleja`,
's9cf68f87b8e6122f': `Azerbaidžānas`,
's9d167ef77aed79b6': `Slānis`,
's9d2d00982edafabb': `Turcijas`,
's9d430adc5be110e9': `Apgrieztā rinda`,
's9d54829be67943d3': `Interlingue`,
's9d54869be6794a9f': `Interlingua`,
's9d668a34af4128ff': `Dzēšana`,
's9df571714a1efb44': `Ir pieejama šī pētāmā objekta automātiski saglabātā versija. Ielādēt to?`,
's9e28faa598332e2b': `Ievietot videoklipu`,
's9e3dbb678150edd4': `Iestatīt fontu ģimeni`,
's9e40e59654c8ad67': `Kolonna`,
's9e85800d3700e31c': `Trase`,
's9e8d3665edde89a6': `Nauru`,
's9eefe6e57e4e1661': `Fonta variants`,
's9f1ecdb3061d9cbc': `Saglabāt telpas`,
's9faf26107ed49fb9': `Tabulas šūnas ievietošana`,
's9fbe26cfd7845469': `Hausa`,
's9fc686f7bbd941e2': `Pāreja`,
's9ff3121d30f88d52': `Parasts`,
's9ffe1bbe64712bf1': `Audekls`,
'sa00df4e39c72d3b4': str`
          ${0} nav atbalstīta 
        `,
'sa013e119fec906fb': `Rinda`,
'sa01e7bf33563ef72': `Priekšvēsture Pielikums`,
'sa126cf8c627cec1e': `Attēlu atveidošana`,
'sa13f72278add7513': `Saskaņā ar tiesībām`,
'sa1647e3b36ec08d7': `Kombinēt vertikālā stāvoklī`,
'sa172190ea21f9b1c': `Piekļūstiet iestatījumiem, atveriet izpētāmo objektu vai izveidojiet jaunu.`,
'sa1c6c459b9b5115c': `Absolute`,
'sa2cba871f6cdd99f': `Asamēzieši`,
'sa2eff4dad1c119f1': `Režģa veidne`,
'sa30c12014e955946': `Krievu`,
'sa30f1981fd1cd441': `Fonta lielums`,
'sa311a24c1471a974': `Dokuments`,
'sa352d168b262aa06': `Ievietot pēdiņu`,
'sa37fee6a52d18063': `Dzēst dokumentu`,
'sa39c7ac1d37f3bce': `Atzīmējiet atlasi kā "divvirzienu izolatoru".`,
'sa3b4c01623211544': `Spēks`,
'sa40fd43756fa8913': `Persiešu`,
'sa417644bef21a9aa': `Nenosaukta tēma`,
'sa43800e28be1bdbc': `Apdares krāsa`,
'sa477cb1825dceb3b': `Sudānas`,
'sa492a51a707930fa': `Ievietot bloka citātu`,
'sa4e5b39489ecf31a': `Xhosa`,
'sa4f137f8619093a5': `Uzraksts apakšā`,
'sa50d3c35533f1d99': `Visi lauki`,
'sa53c5cb03a8fda50': `Piespraust atlasi kā fragmentu paletē`,
'sa557ae6bee9148a6': `Progress`,
'sa589e1df65dde0ec': `Izvēlēto elementu lieluma, aizpildījuma un malu iestatīšana`,
'sa5c371b4bb75e590': `Kreisā`,
'sa5c80e623459ffe4': `Ievietot galveni`,
'sa5df1bcdba46c3fb': `Attēls Virsraksts`,
'sa602e3fd3f2d98fd': `Animācija`,
'sa644d580d8a11e60': `Rubīna izlīdzināšana`,
'sa645d315510dc09e': `Izvēlieties ceļu no diska`,
'sa65d4ad99f1d8c06': `Teksta fona iestatīšana`,
'sa6607436f60ccc1a': `Igauņu`,
'sa6f8d27bca557059': `Pārvietot meta/link/stila elementus uz augšu/uz leju šajā elementā`,
'sa757645ad842da97': `Saglabāt pārtraukumus`,
'sa75b95980cd80e78': `Redaktors`,
'sa7698b3d20a6d1ec': `Ritiniet`,
'sa778acc33947c7b8': `Ekskursijas pabeigšana`,
'sa78a67272a4a6f95': `Matemātikas formula`,
'sa79167651dce1e80': `Alternatīvais teksts`,
'sa7af797a46c7d09a': `Tabulas kājenes`,
'sa7dbe35b758c138d': `Ievietot audeklu`,
'sa7dc6b8ef3f595dc': `Ievietot avotu`,
'sa8279f8211b3950d': `Saglabāt pauzes un atstarpes`,
'sa8b55cab62e439b5': `Noņemt kolonnu`,
'sa8bbe0197d31b423': `Īss apraksts`,
'sa9ff3b762365abe6': `Transformācijas sākumpunkts (z)`,
'saa02e3762368ff35': `Transformācijas sākumpunkts (y)`,
'saa065776236bfa28': `Transformācijas sākumpunkts (x)`,
'saa33768e03c45fc8': `Faila lielums`,
'saaad98061a20ac39': `Ievietojiet matemātisko formulu`,
'saab875d8cfcfe712': `Tēma`,
'saad4380b9cc6cefd': `Aizstājējs pār`,
'saaec15c97a9e4245': `Kolonna Reverse`,
'sab0c57df694a0a09': `Apdares sākums`,
'sab4d9283896d9422': `Noklikšķiniet uz izšķirtspējas pikseļiem`,
'sab55faae8e165407': `Izpildījums&lt;br&gt;, piemēram, sprauga`,
'sab5e7d2a069a2951': `Arodizglītības sertifikāts.`,
'sab726d2db7e6b93d': `Kirundi`,
'sac687b8649989de8': `Izlīdzināt pa labi`,
'sac895c732f350ac5': `Tumšs`,
'saced41ddda8b2354': `Elastīga bāze`,
'sad190f86451081c0': `Nepālieši`,
'sad6be321164d08c8': `Kompakta matemātika`,
'sadd352cc7f6f2307': `Papildus`,
'sae098810f946ca7c': `Tagalo valodā`,
'sae185e6af80ec81e': `Zviedru`,
'sae1c7f13b7c0c47f': `Sākt`,
'sae76e25497dcee58': `Recto`,
'sae9c790b88be7eb9': `Maori`,
'sae9d739068eee2c5': `Tatāru`,
'saf312eaeec77a802': `Ievietot aprakstu sarakstu (glosārijs, terminu saraksts)`,
'saf3da7c95cb17260': `Atzīmējiet atlasi kā virspzīmi`,
'saf440a0a592f2835': `Atjaunināt līdz`,
'saf9e5134ba1a7d30': `Ritināšanas snap`,
'safc6f203342d09e2': `Pārslēdz aktīvā dokumenta priekšskatījumu`,
'sb0a7e3adf4a125ee': `Augšējā labajā pusē`,
'sb0a974028c99ca6d': `Atļaut pielāgojumus?`,
'sb0d4f0f7993cf085': `Iestatiet fonta lielumu`,
'sb0f3327210fe18fc': `Kolonnas`,
'sb0f93c1c60c0249a': `Rubīna bāze`,
'sb1494c08c8c720d1': `Teksta krāsas iestatīšana`,
'sb19611adbc88f711': `Uzlabotas: Piemēram, lai parādītu dokumenta HTML vai pievienotu pielāgotus stilus un skriptus.`,
'sb206d700d26b14ff': `Pasvītrot`,
'sb233557012dcb328': `Pārvietot uz leju`,
'sb26035b596566abf': `Bez nosaukuma`,
'sb2cda80610c8d6ea': `Vieta visiem`,
'sb2dc787b0983ebc6': `Lietuviešu`,
'sb31cdff08b1c5a50': `Sindhi`,
'sb38d497d992ab4a4': `Centrs`,
'sb3ba3276ae93627c': `Ievietot iepriekš formatētu teksta bloku`,
'sb430f5b4824de0d3': `Izvēlieties izkārtojumu`,
'sb43db07b24da018a': `Amhāru valodā`,
'sb45f9fb4dba6e71a': `Nenoteikts`,
'sb4e003a459464d85': `Kurdu`,
'sb4f0310e6787d098': `Uzbekistāna`,
'sb4f1dffbb6be6302': `Skaidrs`,
'sb51270e19988f9bd': `Reģions`,
'sb59d621e3c93cc27': `Kopīgas šūnu robežas`,
'sb5e9e1776242b028': `Mijiedarbība`,
'sb60bc1250aad44c1': `Span`,
'sb60dd9d23d31ee66': `Doktora grāds`,
'sb6103872073d369e': `Ievietot informāciju`,
'sb616811735bfbafd': `Tabulas šūna`,
'sb628960829e223bb': `Izlaist visus pārklāšanās gadījumus`,
'sb6434faf698b02a2': `Shona`,
'sb657bfe93338dc8b': `Volapuk`,
'sb66beca1e766dcb3': `Pieteikties un importēt`,
'sb66e2181a7b5738a': `Iespējot telemetriju, jūs atļaujat datu vākšanu un saglabāšanu saskaņā ar mūsu`,
'sb67e0e7c0869f982': `Atšķirība`,
'sb68e83cda6c85af8': `Tabulas virsraksts`,
'sb6b268120592dc53': `Hindi`,
'sb6ca0a8bb3caae69': `Apdares biezums`,
'sb70c17f7899f9b01': `Latīņu`,
'sb71941f552f3504d': `Iestatīt īpašu vērtību`,
'sb740eab4afd5a710': `Tīkla automātiskā plūsma`,
'sb741b6e0ca589122': `Atgriezt slāni`,
'sb7c77d0415de05cf': `Veikt testus`,
'sb7fb7568f6883ab8': `Kopīgojiet aktīvo dokumentu`,
'sb85774dc5d18ff0f': `Apstipriniet`,
'sb85b1e36579852a6': `Nederīgs e-pasts vai parole`,
'sb884fa76bfc55429': `Arābu valodā`,
'sb8a3d4df7d1c5e6b': `Līdzsvars`,
'sb8f610a0e8df91fc': `Spilgtums`,
'sb8f855b49234b81b': `Piesakies`,
'sb905da066c10182c': `Plus tumšāks`,
'sb940ade1bd81be7e': `Zem kreisās puses`,
'sb9e9a7dd45966756': `Atzīmējiet atlasi kā treknrakstā`,
'sba509fd8ed61d1d5': `Nesaglabāts fails`,
'sba64d8954d027206': `Necaurspīdīgums`,
'sba88d90cd6c751b3': `Kolonnas noteikums`,
'sbaf0a7c417e388af': `Veselība`,
'sbb15d427ee1aa676': `Tigrinya`,
'sbb34f2e3aa40af4e': `Tonga`,
'sbb55f9f2d69fd327': `Aizkadra filtrs`,
'sbb85a407d730e13d': `Ievietot meklēšanu`,
'sbb86c6c96f598bb8': `Jauktais`,
'sbba0156f795d8c07': `Rediģēt atlasi`,
'sbba865d4b437944f': `Atribūts`,
'sbbe639e3a3ed95d1': `NoScript`,
'sbc5bb5bb74d141b9': `Atinstalēt`,
'sbc5f2a81604baf9b': `pozīcija 6`,
'sbc5f2b81604bb14e': `pozīcija 5`,
'sbc5f2c81604bb301': `pozīcija 4`,
'sbc5f2d81604bb4b4': `3. pozīcija`,
'sbc5f2e81604bb667': `pozīcija 2`,
'sbc6953a36ced943f': `privātuma politika`,
'sbd181cd54b8402a4': `Atlases rediģēšana`,
'sbd35ee879d9cf770': `Rubīna teksts`,
'sbd40f40cbadd38d5': `Noņemt šo logrīku paketi`,
'sbd72dc858de95ce8': `Birmas`,
'sbe3c60c65f129daa': `Humanitārās zinātnes`,
'sbe4a7c8f231739b3': `vai ielīmēt/nomest/izvēlēties failu`,
'sbe90de083557ef3e': `Svahili`,
'sbefb6064cba01844': `Ievietojiet rindas pārrāvumu`,
'sbf00e1ee999ea94e': `Ievietot skriptu`,
'sbf519920c2017d67': `Piekaramais`,
'sbfa01f189a68d3e9': `Flex augt`,
'sbff54e740c4086eb': `Rādīt nezināmas paketes`,
'sbfff51feacf30196': `Sanskrits`,
'sc0ceaa9843510f67': `Turkmēņu`,
'sc1611c0558728a2a': `Pozīcija`,
'sc1a155cc25899250': `Tabulas rindu grupa`,
'sc1aa1f6051b7102a': `Rumāņu`,
'sc1edebeaef92b7bd': `Fiksēts galda izkārtojums`,
'sc1fff4f356dfb2fb': `Pārveidot`,
'sc221faca1ecb4aee': `Anonīms`,
'sc24bda3c061fddf8': `Klikšķināmā zona`,
'sc252a4e091763606': `Tabulas pēdas ievietošana`,
'sc2536e077514accc': `Ritināšana`,
'sc275dd00036d16cb': `Citāti raksturs`,
'sc28864200d2a3799': `QR koda kā attēla kopēšana`,
'sc2a24a9dd41a9503': `Apdares līnija`,
'sc2b734cca2fa643b': `Pan (uz leju)`,
'sc2e2a0dbf03723b7': `Uzlabotas: Rādīt paketes no nezināmiem avotiem pakotņu pārvaldniekā (Brīdinājums: var būt nedrošs)`,
'sc3998b77d72c2932': `Tīmekļa vietnes ievietošana (kā iebūvētu rāmi)`,
'sc3ac225273c8316b': `Vispārīgi`,
'sc3cfee84dbbf36ae': `Vietējā datne`,
'sc3f09a9b6fa4fbed': `Iekšpusē`,
'sc43767deea72e9f3': `Apraksts Saraksts`,
'sc462bbdd36bcba6b': `Atsauces lodziņš`,
'sc4ee3e4ee994dafd': `Ukraiņu`,
'sc50d09edf9325339': `Dialogs`,
'sc52b67794c06a0d3': `Perspektīvas sākumpunkts (y)`,
'sc52e8b794c0913d6': `Perspektīvā izcelsme (x)`,
'sc53de149fcaad713': `Starp rakstzīmēm`,
'sc546f489f9c0cced': `Pārslēdz aktīvā dokumenta pārbaudes režīmu.`,
'sc5bcf50d1b578d9f': `Fontu funkciju iestatījumi`,
'sc5cb39478b9b7625': `Atzīmējiet atlasi kā apakšsarakstu`,
'sc6415b50ff928294': `Saraksta vienība`,
'sc650ff15b20fe9d3': `Pagriezt (z)`,
'sc6578b15b2154365': `Pagriezt (x)`,
'sc65aff15b2183e58': `Pagriezt (y)`,
'sc6da0f4a7e4d710e': `Fontu valodas pārrakstīšana`,
'sc74e3567875ce255': `Gan jūsu logrīka tagu, gan NPM paketes nosaukumu.`,
'sc7eb080b96e244df': `Malay`,
'sc8ac7ef92b95df3f': `Pārvietot (x)`,
'sc8af536e2084ade0': `Palete`,
'sc8b022f92b992bc2': `Pārvietot (y)`,
'sc8b39af92b9c2d81': `Pārvietot (z)`,
'sc8d2c7f6c33a2b32': `Izvēlēto elementu teksta stila iestatīšana (izlīdzināšana, atkāpes, atstarpes utt.)`,
'sc8fa0e3de389ef1c': `Fonta lieluma pielāgošana`,
'sc9474bf7a0668d73': `Kopsavilkums`,
'sc94e314312a8900c': `Čehu`,
'sc980855a000b76ea': `Apakšējā daļa`,
'sc98b103772de63f4': `Somu`,
'sca7cfe2bef51b2a5': `Saknes`,
'sca7fed2bef53cb99': `Loma`,
'scabe6ecee5e01fd2': `Maltas`,
'scace301a88231cce': `Ievietot`,
'scbc55f622ec078c1': `Skatīt lodziņu`,
'scbe537fc38ff4c13': `Režģa automātiskās kolonnas`,
'scc1db59d292cbc4c': `Sadaļa`,
'scc56b218a2689c42': `Armēņu`,
'scc5ba32e0de06744': `Sesoto`,
'scd15088c39fe9edf': `Papildinājuma lodziņš`,
'scd9cedeb5ece3adb': `Domuzīme`,
'scdf536b65be39ec5': ` Izveidot/importēt`,
'sce8a4e3f7c98482d': `Sisvatī`,
'scec2be75ee985f6c': `Ideogrāfiskais`,
'sceecdd0bb404bc17': `Ievietot opciju grupu`,
'scf00d48fd5953a03': `Grieķu`,
'scf932840a69dbb7c': `Portugāļu`,
'scf932a8577057752': `Footer`,
'scf95dcb12a950a5c': `Aymara`,
'scfcb70f2a15eaf14': `Apakšējā labajā pusē`,
'sd01178c54f648118': `Bilances kolonnas`,
'sd03bff50f87f82d4': `Domuzīmes raksturs`,
'sd05a155fe09c2866': `Tiešsaistē, izmantojot`,
'sd0864ea6cb6ef22e': `Kopiena`,
'sd10fdbe6caf9a998': `Līnijas pārrāvums`,
'sd121d3b959b7888d': `Ātruma optimizēšana`,
'sd1a78e667a1a139f': `Atzīmējiet atlasi kā ievietošanu`,
'sd1cffad290ea5b3b': `Saglabājiet visus`,
'sd1f10284eeb17b25': `Fidži`,
'sd1f44f1a8bc20e67': `E-pasts`,
'sd1f81984eeb7c0e8': `Aizpildiet`,
'sd29dc07235eea0f5': `Citāts`,
'sd2addf69477cd4b4': `Importa pakete`,
'sd2ed26defc646d47': `Aizkadra filtrs`,
'sd2ef82b8ea877c6d': `Afrikaans`,
'sd319aae1401f1e19': `Fiksēts`,
'sd3a288c1094b8a63': `Kolonnu noteikumu platums`,
'sd3c65ef5c380c046': `Ievietotie`,
'sd3dcb76f7b28adb8': `Latviešu`,
'sd3eca1e0f4209f6e': `Apgriezt visu`,
'sd3f402df8619ddcd': `Šī informācija par jums tiek automātiski pievienota jauniem dokumentiem. To var
          mainīt katram dokumentam metadatu redaktorā.`,
'sd4368b12645d3c0f': `Ievietot portālu`,
'sd452cebf4a0313d1': `Rādīt avota rediģēšanas komandas`,
'sd48cc52117f4d68b': `Itāļu`,
'sd52660ee947ca58b': `Tabulas kolonnas ievietošana`,
'sd588d17a1b25c220': `Teksta pārplūšana`,
'sd5be6f6d85fc0c9b': `Zulu`,
'sd5bf67958b08b4cf': `Augstākā izglītība.`,
'sd5cf95145e4d89ca': `Atpin šo fragmentu`,
'sd5fd9d11a92f5b1d': `Apakšējā kreisā (y)`,
'sd60c9bbc51375635': `Ievietot pogu`,
'sd66c4767fa3dde28': `Akcenta krāsa`,
'sd679c8b1bf8cc8a5': `Mazās kapitā`,
'sd7086c4425c53c80': `Fontu ģimene`,
'sd837f42ac7cbfb58': `Forma (ārpusē)`,
'sd88076d2994ee0fb': `Izslēgšana`,
'sd89a2e529b31ef43': `Atgriezt`,
'sd8a345e95668b73b': `Vertikāli, no labās puses uz kreiso`,
'sd8ce9e57270b030d': `Fontu izstiepšana`,
'sd8ecf227c7c49331': `Matemātiskais`,
'sd8f923198e0c5c6a': `Izbeigt`,
'sd9c21e5f60d6bdd8': `Dānijas`,
'sd9ff8e2612e63d50': `Robežu lodziņu lieluma noteikšana`,
'sda2d76b976502a8d': `Atvērt...`,
'sda344aacb837387e': `Atrašanās vieta konteinerā`,
'sda5b6fa8b771f996': `Peldēt pa kreisi`,
'sda9254d1f1228e1a': `Ungāru`,
'sdb1595f5c742dfbb': `Ieeja`,
'sdb711380a28fec75': `Ievietot sarakstu (sakārtotu)`,
'sdb73788b3c975f16': `Auto`,
'sdbee7e0523a23a42': `Apakšējā labajā pusē (y)`,
'sdc12d4d35420eeb7': `Komentāri`,
'sdc48456f9a27ae02': `Ģenerators`,
'sdc70d81cf6c28533': `Gruzīnu`,
'sdd1ff479d04ac140': `Publiski`,
'sdd2fc8919a9c3111': `Fona blendēšanas režīms`,
'sdd35b688281b6dea': `Japāņu`,
'sddc49047f66a64ab': `Apraksts nav sniegts`,
'sdef34fe08bb28b09': `Ķīniešu valoda (vienkāršotā)`,
'sdf62e305e1594805': `Atzīmējiet atlasi ar rubīna anotāciju`,
'sdf946172dfa0328f': `Virsraksts`,
'sdf9bc5d9b7f3e3de': `Saskaņošana`,
'se036b53f145441cd': `Jaukts saturs`,
'se06f459fccdc3ce9': `Pēdējās teksta rindas izlīdzināšana`,
'se0a782a8be8e018b': `Norvēģu`,
'se0cda6b80a1bb50f': `Slovākijas`,
'se0f67eae944f8f94': `Izslēgt mikrofonu`,
'se1312d6528f9a259': `Joruba`,
'se16c5e66886fbc59': `Raksts`,
'se1f5bb0386c88f96': `Iestata atlasītā teksta krāsu`,
'se219da7b1e955c65': `Skaidrs formatējums`,
'se25e4f2cb77b8be8': `WebWriter saskarnes valoda un jauni dokumenti`,
'se2796c5824ec8916': `Satura redzamība`,
'se308836a594808b6': `Singhalese`,
'se36c5b1baf5e0660': `Jebkur`,
'se39c065efa467782': `Basku`,
'se3b4c857f91f80d7': `Tastatūras saīsnes`,
'se47baf2fd16b9d2b': `Šablons`,
'se48bd9e6c2a3109d': `Konti`,
'se58467472725ad0c': `Attēlu izšķirtspēja`,
'se58f06c2b0583ff7': `Izvēlieties koordinātes`,
'se5dc1e97fb743ade': `Attālums`,
'se619a501d1bfe6a5': `Wrap`,
'se62385ac082368d2': `Atzīmējiet atlasi kā citēšanas avotu`,
'se6297163cac9d276': `Rediģēt avotu`,
'se633223a0b88625e': `Šūnu izvietojums`,
'se638417c560cfe5c': `Ielauzties iekšā`,
'se64f418b4e733b6c': `Ievietojiet izvades`,
'se79c0a3ac70d8fb3': `Asp. koeficients (x)`,
'se79fae3ac710dc36': `Asp. attiecība (y)`,
'se7fad370d8fb4cec': `Optimizēt salasāmību`,
'se8a94b4effa2033e': `Alfabētiskais`,
'se95d4e55ea186d9a': `Ritjoslas krāsa`,
'se96d43a515b8451c': `Slovēņu`,
'se96fd76ba1b2975a': `Centrālais`,
'se9ac05f36b004eb0': `Paslēpt iepazīšanās ekskursiju. Izslēgt, lai tūre atkal tiktu parādīta.`,
'se9b1fec72ffd8f48': `Vietējais`,
'sea24bdcaa2bd2dec': `Obligāts snap`,
'sea52df2b70a5c10d': `Rubīns`,
'sea6e7291e27ec53f': `Pārslēdz metadatu redaktoru`,
'sea896ed51ad33287': `Nav pieejami īpaši stili`,
'seaaaeb09e3b4e78b': `Rediģēšanas komandas`,
'seabae79729c4b2ad': `Pārslēgt e-pastu`,
'seaecc8267bad6234': `Vidusskola`,
'seaf97719986faf4f': `Plaisa`,
'seb19675a580f0628': `Izvairieties no kolonnas`,
'seb4e52ef5ec7a7dc': `Krāsas/efekti`,
'seb8982ae8c3cdcc5': `Indonēzijas`,
'sebbced89e0db2894': `Pirmā bāzes līnija`,
'sec02109a0dd2a6c8': `Uzsvars krāsa`,
'sec2557a35b702525': `Mainīgs`,
'sec2da4aa7a02b925': `Islandiešu`,
'sec30fbb20f102670': `Ievietot kopsavilkumu`,
'sec8b0b6c729816b6': `Virsrakstu grupa`,
'seccd05955adb76bc': `Plakāts`,
'sed17285cd25d6389': `Katalogs, kurā atrodas package.json`,
'sed318ec045c5144f': `Virs`,
'sed713f1b916fb469': `Attālums starp robežām (x)`,
'sed74a31b9172942c': `Attālums starp robežām (y)`,
'sed86bd0deb2e5372': `Pārveidot tekstu`,
'see2fcaedf9743ec6': `Atrašanās vieta`,
'seec6798afe90ffc8': `Drukāt`,
'sef00c258bc1ecf1e': `Šajā izpētāmajā ir nesaglabātas izmaiņas.`,
'sef23dd271edd4a8b': `Apakšējā kreisajā pusē`,
'sef24caccbd4645ef': `Elastīga saraušanās`,
'sef49aec68fd1dc66': `Nosaukums`,
'sef73fe18e351eb35': `Atslēgas vārdi`,
'sef75f458d77491af': `Iespēju grupa`,
'sefcf950b3cc4fc3b': `Valoda`,
'sf0c8e2b013e5ff18': `Bhutani`,
'sf0ca10f343249063': `Saturs`,
'sf0cab2483f66aa2e': `Pielāgots`,
'sf0e261e04eda82ff': `Izskats`,
'sf1045382c1fd9a85': `Precīzas drukas krāsas`,
'sf14c35392ec7bf10': `Šī funkcija nav pieejama pārlūkprogrammā Firefox. Tā ir pieejama pārlūkprogrammā Chrome vai Edge.`,
'sf14f9d5f9f6ca342': `Plus vieglāks`,
'sf1868dc19e3917bb': `Spāņu`,
'sf190149f9d8bbb2a': `Rakstīšanas režīms`,
'sf1e79171c4856543': `Vai esat pārliecināts? Šo darbību nevar atcelt, visi jūsu iestatījumi tiks dzēsti un
          atiestatīti.`,
'sf21c1f60c7515f44': `Atzīmējiet atlasi kā parauga izvadi`,
'sf21fb4f4b9e8911f': `Platums`,
'sf22a3737146ec910': `WebWriter var ievietot SVG tieši dokumentā.`,
'sf2514d5dc78b1654': `Ievietot logrīku`,
'sf28903d4ca0ddcfc': `Noņemt šo kontu`,
'sf2ab37af0abc55ef': `Paslēpt iepazīšanās tūre`,
'sf2bdb0b4d7b9c039': `Bengāļu`,
'sf2cbb5e519264e67': `Izmēra maiņa gan horizontāli, gan vertikāli`,
'sf2d5cbc2fe0ad65a': `Sticky`,
'sf2d96d0eb32cb81f': `Animācijas kompozīcija`,
'sf2de3dbe2108637a': `Formas atveidošana`,
'sf2e08a945e9194d4': `Welch`,
'sf34696c526e810b4': `Inline`,
'sf39736a666dbb038': `Dziesmas ievietošana`,
'sf3c4da68b08a2590': `Madagaskaras`,
'sf471ec2496f904cc': `Izmest izmaiņas`,
'sf4849bc200e279ed': `Tabulas virsraksts`,
'sf486ca1fdbe08645': `Ievietot skaitli`,
'sf4b537d4cbd8f5fd': `Teksta augšdaļa`,
'sf4e0e02a5277ef23': `Ievietot teksta laukumu`,
'sf4f067d41efd4b83': `Mērogs (y)`,
'sf4f3cbd41f002b46': `Mērogs (x)`,
'sf4fa67d41f05a008': `Mērogs (z)`,
'sf5197db2d5f2926a': `Pagrieziet`,
'sf52d840949a980d1': str`
          ${0}
          tiks dzēsts uz visiem laikiem. Vai esat pārliecināts? 
        `,
'sf55d634dcc743595': `Pakalpojumi`,
'sf59c9081d106dd9c': `Atzīmējiet atlasi kā mainīgo`,
'sf5e76f774beb33c2': `Inuktitut`,
'sf64a8229a8136552': `Dokumenta dzēšana`,
'sf65df67a03bebe4b': `Nepieciešams šim logrīkam`,
'sf6673729c03ae999': `WebWriter atiestatīšana`,
'sf67571992e7dc88e': `Pilns termiņš`,
'sf6b4934598f7ed10': `Atļaut atlasi`,
'sf6e1665c7022a1f8': `Parole`,
'sf79e0d78b56444f1': `Inline beigas`,
'sf7a5f7a7c80c3082': `Abi`,
'sf7c0eba7c822e3d6': `Bold`,
'sf86bd4d2982f3b74': `Atzīmējiet atlasi kā kodu`,
'sf8e82313fa411494': `Atzīmējiet atlasi kā saiti`,
'sf955eff73fb6b573': `Serbijas`,
'sf9929e2d356260c5': `Reizināt`,
'sf993bb199fefbe04': `Visi`,
'sf9ecf969dd4b8164': `Abas malas`,
'sf9f2c719a04066ec': `Lietotne`,
'sfa49a5bb1a5d353e': `Privāta piekļuve`,
'sfa59c7777e2a0eeb': `Datu saraksta ievietošana`,
'sfaa0a67db5c11f72': `Pirmās teksta rindas atkāpe`,
'sfb231a52211b133f': `Nav teksta ietīšanas`,
'sfb68cae41d749423': `Sākotnējais`,
'sfb9b6edb0ed378c9': `Citēšanas avots`,
'sfbbab09dbe553571': `Vektora zīmējuma (SVG) ievietošana`,
'sfc00292e778b67e2': `Mērītājs`,
'sfc63e31ac7c956ed': `Atlasiet`,
'sfc815c9078bba30a': `Lejupielādēt QR kodu kā attēlu`,
'sfcdd8e672c75b713': `Adrese`,
'sfcebd18506f1e535': `Plūsma`,
'sfd0cde85070d2eb2': `Flex`,
'sfd77270c3f54f664': `Izvades`,
'sfdb1e4d90981a535': `Kopīgojiet šo dokumentu`,
'sfdeef3dccf409f81': `Šis atslēgas vārds ir nepieciešams logrīkiem.`,
'sfe6e758ad2603c1d': `Maģistra grāds`,
'sfee1c12daf838935': `Krāsu apdegums`,
'sff303daee4dd9f7b': `Lingala`,
'sff3df0c2823ec6e4': `Verso`,
'sff99962304ac7d25': `Dialoglodziņa ievietošana`,
'sffa395f64ec6ac36': `Bulgāru`,
'sffdadf0a576fd802': `Augstums`,
'spaceKey': `Telpa`,
'tabKey': `⭾ Cilne`,
'upKey': `↑ Uz augšu`,
    };
  